<template>
  <v-menu open-on-hover offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
        class="hidden-sm-and-down"
      >
        <template v-if="headerKey">
          <SiteText :k="headerKey" tag="span">{{ headerDefault || header || '' }}</SiteText>
        </template>
        <template v-else>
          {{ header }}
        </template>
        <v-icon right>mdi-menu-down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in items" :key="item.k || item.key || index" link router :to="item.route">
        <v-list-item-title>
          <template v-if="item.k || item.key">
            <SiteText :k="item.k || item.key" tag="span">{{ item.title }}</SiteText>
          </template>
          <template v-else>
            {{ item.title }}
          </template>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import SiteText from './SiteText'

export default {
  name: 'AppDropdown',
  components: { SiteText },
  props: {
    // legacy string header
    header: {
      type: String,
      default: '',
    },
    // key-based header support (preferred)
    headerKey: {
      type: String,
      default: '',
    },
    headerDefault: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
